import '@babel/polyfill'
import 'nodelist-foreach-polyfill'
import Swiper, {Navigation} from 'swiper';

function setOffset () {
  var width = window.innerWidth || document.documentElement.clientWidth
  var offset = width >= 1200 ? (width - 1140) / 2 : 15

  this.params.slidesOffsetBefore = offset
  this.params.slidesOffsetAfter = offset
  this.update()
}

export default () => {
  window.trainingsCarousel = new Swiper('.js-trainingsCarousel', {
    modules: [ Navigation ],
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 10,
    navigation: {
      prevEl: '.c-trainings__button.-prev',
      nextEl: '.c-trainings__button.-next'
    },
    breakpoints: {
      767: {
        spaceBetween: 30
      }
    },
    on: {
      init: function () {
        //setOffset.apply(this)
      },
      resize: function () {
        //setOffset.apply(this)
      }
    }
  })
}
